import React from 'react';
import Icon from 'components/Icon';
import { PasswordNeedWrapper } from './styledComponents';

const PasswordNeed = ({ text, hasError }) => (
  <PasswordNeedWrapper hasError={hasError}>
    <Icon
      name={hasError ? 'invalid_field' : 'valid_field'}
      size='10'
    />
    {text}
  </PasswordNeedWrapper>
);

export default PasswordNeed;



// WEBPACK FOOTER //
// ./src/components/InvalidPasswordModal/PasswordNeed.js